import { z } from "zod";
import { Locales } from "@/lib/i18n";
import { __ } from "@/lib/i18n/functions";
import { createPhoneSchema } from "@/lib/validation/phone";

export const createContactUsLocalisedSchema = (locale: Locales) => {
  const titleSchema = z.enum(["mademoiselle", "madame", "monsieur"], {
    required_error: __("Please select a title", locale),
  });

  const firstNameSchema = z
    .string({ required_error: __("First name is required", locale) })
    .trim()
    .min(3, __("Invalid First name", locale));

  const lastNameSchema = z
    .string({ required_error: __("Last name is required", locale) })
    .trim()
    .min(3, __("Invalid Last name", locale));

  const emailSchema = z
    .string({ required_error: __("Email is required", locale) })
    .trim()
    .email(__("Invalid email", locale));

  const phoneSchema = createPhoneSchema({
    required: __("Phone number is required", locale),
    invalid: __("Invalid phone number", locale),
  });

  const messageSchema = z.string().optional();
  const cguSchema = z.boolean().refine((isAccepted) => isAccepted, {
    message: __("You must accept the terms and conditions", locale),
  });
  const receiveNewsSchema = z.boolean().optional();

  const contactUsSchema = z.object({
    title: titleSchema,
    firstName: firstNameSchema,
    lastName: lastNameSchema,
    email: emailSchema,
    phone: phoneSchema,
    message: messageSchema,
    cgu: cguSchema,
    receiveNews: receiveNewsSchema,
  });

  return { contactUsSchema };
};

type SchemaSet = ReturnType<typeof createContactUsLocalisedSchema>;

export type ContactUsSchema = z.infer<SchemaSet["contactUsSchema"]>;
